// Centralized runtime feature flags and config
export const CONFIG = {
  // When true, the app should run in "Arsenal" tenant mode.
  // Set in environment: VITE_ARSENAL_MODE=true
  enableArsenalMode: import.meta.env.VITE_ARSENAL_MODE === 'true',
} as const;

export const isArsenalMode = (): boolean => CONFIG.enableArsenalMode;
